import { TAB_MORE, UPDATE_MEMBER_LEAVE } from '../constants/actionTypes'
import ACTS from '../constants'

const defaultStatus = {
    title: '내 정보'
}

export default (state = defaultStatus, action) => {
    switch(action.type) {        
        case ACTS.MAIN_INFO:            
            return {
                ...state,                
                items: action.payload.item
            }    
        case ACTS.GET_CERTIFY_LINK_DELETE_DATA:            
            return {
                ...state,                
                linkList: action.payload.list
            }
        case ACTS.GET_CERTIFY_LINK_DELETE_DATA_END:            
            return {
                ...state,                
                linkList: null
            }
        default:        
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/main.js